<div class="bg-white conteiner ">
  <div class="header2 d-flex">
    <div class="d-flex"><span class="namePopUp m-3 ">WARNING</span></div>

  </div>
  <div>
    <div class="Texto col-12 d-flex ">
      <span class="warning mt-1">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 30 30"
          aria-hidden="true">
          <circle cx="0.75em" cy="0.75em" r="0.75em" fill="#F2CB00" />
          <path fill="#fff"
            d="M11.351 6.351A1.2 1.2 0 0 1 13.4 7.2V12a1.2 1.2 0 1 1-2.4 0V7.2a1.2 1.2 0 0 1 .351-.849Zm.182 9.451a1.2 1.2 0 1 1 1.334 1.996 1.2 1.2 0 0 1-1.334-1.996Z" />
        </svg>

      </span>
      <div>
        <p><strong></strong></p>
      </div>

      <div>
        <p>Do you want to continue?</p>
      </div>
    </div>
    <div class="col-10 botones  ">
      <button class="btnSave col-6" type="submit" (click)="close(true)">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24"
          aria-hidden="true">
          <path fill="#000F41" stroke="#000F41"
            d="m18.355 7.562.008.008.008.007a.5.5 0 0 1 0 .735l-.008.007-.007.007-8.16 8.16-.001.002a.501.501 0 0 1-.71 0l-.002-.002-3.84-3.84-.006-.006a.521.521 0 0 1 .723-.753l3.126 3.136.354.355.354-.355 7.45-7.46v-.001a.5.5 0 0 1 .71 0Z" />
        </svg>

        Accept
      </button>

      <button class="btnCancel col-6 ml-5" type="submit" (click)="close(false)">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 13 13"
          aria-hidden="true">
          <path fill="#000F41"
            d="m7.979 6.004 4.307-4.29A1.003 1.003 0 0 0 11.575 0c-.267 0-.523.106-.711.294l-4.297 4.3L2.27.294a1.007 1.007 0 0 0-1.717.71c0 .266.106.522.294.71l4.307 4.29-4.307 4.29a1 1 0 0 0 .326 1.639 1.002 1.002 0 0 0 1.097-.219l4.297-4.3 4.297 4.3a1.003 1.003 0 0 0 1.641-.325.998.998 0 0 0-.219-1.095L7.98 6.004Z" />
        </svg>

        Cancel
      </button>
    </div>
  </div>